import React from 'react'
import Background from 'src/components/background'
import { SidebarProvider } from 'src/components/ui/sidebar'
import { SidebarNav } from './sidebar'
import { Header } from 'src/components/header/newheader'

interface DashboardLayoutProps {
  children: React.ReactNode
}

export function NewDashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <SidebarProvider>
      <Background>
        <div className="flex min-h-screen w-full">
          <SidebarNav />
          <div className="flex-1 flex flex-col ">
            <Header />
            <main className="flex-1 p-4">{children}</main>
          </div>
        </div>
      </Background>
    </SidebarProvider>
  )
}

export function getUpdatedAdminLayout(page: React.ReactNode) {
  return <NewDashboardLayout>{page}</NewDashboardLayout>
}
